import { createBrowserRouter } from "react-router-dom"
import App from "./App"
import Home from "./pages/Home"
import Estimator from "./pages/Estimator"
import NotFound from "./pages/NotFound"

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: "estimate", element: <Estimator /> },
      { path: "*", element: <NotFound /> },
    ],
  },
])
